import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useWorkStateFields, useStateFields } from '../../store/hooks';

import './Activity.css';
import StoreToken from '../../components/StoreToken';
import Navbar from '../../components/Navbar/Navbar';
import { get_platform_action_color, getAPIUrl, getAuthToken, globalLoader,
         token_url } from '../../script/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { Toast, copyTextToClipboard } from '@egreact/shared';
import WorkDetailHeader from '../WorkDetail/WorkDetailHeader';
import { getCurrentPage } from '../WorkDetail/work_utils';
import * as CONST from '../../script/const.js';
import { useLocation } from 'react-router-dom';
const Activity = () => {
    const { isLoggedin } = useStateFields(['isLoggedin']);
    const { storeToLocal } = StoreToken();

    useLayoutEffect(() => {
        storeToLocal();
    }, []);

    const [accessedLinks, setAccessedLinks] = useState([])
    const [loading, setLoading] = useState(false)
    const {
        currentDimensions, setCurrentDimensions, showToast, setShowToast,
        toastMessage, setToastMessage, setRedirectUrl,
    } = useWorkStateFields(['currentDimensions', 'showToast', 'toastMessage']);
    const currentPage = getCurrentPage(CONST, CONST.ACTIVITY);
    const location = useLocation();
    const handleOrientationChange = () => {
        setCurrentDimensions(window.innerWidth)
    };


    const getAccessedLinks = async () => {
        setLoading(true);
        try {
            const res = await fetch(getAPIUrl(`/api/share/user_accessed_links/`), {
                method: 'GET',
                headers: {
                    Authorization: getAuthToken(),
                },
            });
            const myRes = await res.json();

            if(myRes.success){
                setAccessedLinks(myRes.accessed_links);
            }
        } catch (error) {
            console.error("Error fetching accessed links:", error);
        } finally{
            setLoading(false);
        }
    }

  const handleCopy = (url) => {
    copyTextToClipboard(url.share_link)
    setShowToast(true)
    setToastMessage({'title': 'Copied'})
  };

    useEffect(() => {
        getAccessedLinks();
    }, [])

    useEffect(() => {
      const storedHistory = JSON.parse(localStorage.getItem('nav_history')) || [];
      setRedirectUrl(storedHistory)
    }, [location, accessedLinks]);

    useEffect(() => {
        window.addEventListener('resize', handleOrientationChange);

        return () => {
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    const groupedLinks = accessedLinks.reduce((acc, link) => {
      if (!acc.has(link.booking_pk)) {
        acc.set(link.booking_pk, {
          booking_name: link.booking_name,
          links: []
        });
      }
      acc.get(link.booking_pk).links.push(link);
      return acc;
    }, new Map());

  return (
    (isLoggedin && <>

    {loading ? <div className='fullpage-overlay'>
        {globalLoader()}
    </div> :

        <div>
        <Navbar title={"Dashboard"} location={token_url(`${process.env.REACT_APP_STAG_URL}`)} />

        {loading &&  <div className='fullpage-overlay'>
                            {globalLoader()}
                        </div>}

        <div>
            <WorkDetailHeader currentPage={currentPage} activityTab={true}/>
            <div style={{marginTop: currentDimensions > 1200 ? '12rem': '7rem'}}>
                <h1 style={{marginBottom: currentDimensions > 1200 ? '2rem' : '0.8rem', fontSize: currentDimensions > 1200 ? '1.5rem': '1.3rem', fontWeight: 'bold'}}>Your Recently Visited URLs</h1>
                <div className='share-details-container'>
                {Array.from(groupedLinks.entries())?.map(([bookingPk, group], index) => (
                  <div key={bookingPk} className="booking-dropdown-card">
                    <details className="dropdown-card" open={index === 0}>
                      <summary className="dropdown-summary">
                        <div style={{ fontSize: currentDimensions > 600 && "larger", maxWidth: "72%", paddingLeft: "3%" }}>
                          {group.booking_name?.length > 35
                            ? group.booking_name.slice(0, 33) + "..."
                            : group.booking_name}
                        </div>
                        <div style={{ paddingRight: "5%", fontSize: "14px" }}>
                          ({group.links.length} {group.links.length>1?"urls":"url"})
                        </div>
                      </summary>

                      <div className="dropdown-content">
                        {group.links.map((e, index) => (
                          <div key={e._id} className="share-details-item">
                            <div
                              className="share-url"
                              style={{
                                color: e.is_disabled && "grey",
                                opacity: e.is_disabled && "0.6",
                              }}
                            >
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={e.share_link}
                                style={{ 
                                  marginRight: "30px",
                                  lineHeight: "1.2",
                                  textAlign: "left",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                  whiteSpace: "normal",
                                  maxWidth: currentDimensions < 600 && "10rem",
                                  color: e.is_disabled ? "rgba(13, 117, 117, 0.6)" : get_platform_action_color(),
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  pointerEvents: e.is_disabled && "none"
                                }}
                              >
                                <span style={{ fontSize: currentDimensions < 600 ? "14px" : "17px", textDecoration: "underline",}}>{e.hidden_base_view_url}</span>
                                {e.is_disabled && <div style={{marginLeft: currentDimensions>600 && '10px', color: 'white',  padding: currentDimensions < 600 ? '2px 4px':'4px', background: 'gray', borderRadius: '10px', fontStyle: 'normal', width:'fit-content', marginTop: currentDimensions<600 && '4px', fontSize: '12px', textDecoration:"none"}}>Disabled</div>}
                              </a>

                              <button
                                className="copy-btn"
                                onClick={() => handleCopy(e)}
                                style={{
                                  pointerEvents: e.is_disabled && "none",
                                  backgroundColor: e.is_disabled && "grey",
                                  maxWidth: "fit-content",
                                }}
                              >
                                <FontAwesomeIcon icon={faCopy} style={{ color: "#ffffff" }} size="lg" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </details>
                  </div>
                ))}
                </div>
            </div>

        </div>
        {showToast && <Toast message={toastMessage} duration={toastMessage?.hide_in} onClose={() => setShowToast(false)}/>}
    </div>
                        
    }

    </>)
  )
}

export default Activity